import { Button } from "@mui/material";
import React from "react";

import { CONTENT_ADD_TEAMS } from "../state/actions";

const DeleteConfirmation = ({ closeModal, setConfirmation }) => {
  const handleCancel = () => {
    closeModal();
  };
  const handleDelete = () => {
    setConfirmation(CONTENT_ADD_TEAMS);
  };
  return (
    <div
      id="Content-Confirm-Delete-Law-Firm-Teams"
      data-testid="Content-Confirm-Delete-Law-Firm-Teams"
    >
      <div className="py-4 text-center text-xl">Are you sure you want to delete these records?</div>

      <Button
        className="border-solid-2 m-2 border-blue-500 capitalize hover:text-blue-500"
        variant="outlined"
        onClick={() => handleCancel()}
      >
        Cancel
      </Button>
      <Button
        className="border-solid-2 m-2 border-red-600 bg-red-600 capitalize text-white hover:text-red-600"
        onClick={() => handleDelete()}
      >
        Delete
      </Button>
    </div>
  );
};
export default DeleteConfirmation;
